'use client';

import { useEffect } from 'react';
import { captureUTMParams } from '@/lib/tracking';

/**
 * UTMCapture component captures UTM parameters from the URL on initial page load
 * and stores them in localStorage for persistent tracking across the session.
 *
 * This component renders nothing (null) and should be included in the root layout.
 */
export default function UTMCapture() {
  useEffect(() => {
    // Capture UTM parameters from URL on mount
    captureUTMParams();
  }, []); // Empty dependency array ensures this runs only once

  return null; // This component doesn't render anything
}
